import ProfitBonusActivity from './index'

export default {
  path: '/home/profitBonus/activity',
  component: ProfitBonusActivity,
  meta: { titie: '盈加码活动' },
}
